import type { LabelVariant } from "@onestore/hel/dist/components/atoms/LabelAtm/LabelAtm.types"
import type Theme from "@onestore/hel/dist/typings/theme"
import { getBrand } from "~/lib/config"

// Global
export const notificationIconColor: Theme.Color =
  getBrand() === "home" ? "b4" : "success"

export const notificationBackground: Theme.Color =
  getBrand() === "home" ? "k1" : "successLight"

export const buttonColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const labelVariant: LabelVariant =
  getBrand() === "home" ? "blue" : "successLight"

export const labelIconColor: Theme.Color =
  getBrand() === "home" ? "b4" : "success"

export const checkboxColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const radioButtonColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const priceColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const priceColorUDS = getBrand() === "home" ? "" : "text-accent"

// Upsell
export const upsellDescriptionIconColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const inputPlaceholderColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const searchResultExtensionColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const searchResultItemLabelColor: Theme.Color =
  getBrand() === "home" ? "k1" : "successLight"

// PaymentBox
export const paymentBoxSummaryPriceColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const paymentBoxSubItemColor: Theme.Color =
  getBrand() === "home" ? "b4" : "success"

export const paymentBoxSubItemBackground: Theme.Color | undefined =
  getBrand() === "home" ? "k1" : undefined

export const paymentBoxMessageAccordionInfoColor: Theme.Color =
  getBrand() === "home" ? "b4" : "black"

export const paymentBoxMessageAccordionInfoBackground: Theme.Color =
  getBrand() === "home" ? "k1" : "successLight"

// Payments element
export const paymentsElementLabelVariant: LabelVariant =
  getBrand() === "home" ? "blackWithBorder" : "successLightWithBorder"

export const paymentMethodColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

// Email hack upsell
export const emailHackUpsellLabelVariant: LabelVariant =
  getBrand() === "home" ? "blackWithBorder" : "successLight"

export const emailHackUpsellLabelTextColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

// Others
export const domainsMailBoxTitleColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const discountValueColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const validationIndicatorColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const stepsIconColor: Theme.Color =
  getBrand() === "home" ? "black" : "success"

export const clearModalButtonColor: Theme.Color =
  getBrand() === "home" ? "black" : "primary"

export const clearModalIconColor: Theme.Color =
  getBrand() === "home" ? "b4" : "error"
